import { useContext } from "react";
import { NotificationContext, type NotificationContextType } from "@/contexts/notification-context";

export function useNotificationContext(): NotificationContextType {
  const ctx = useContext(NotificationContext);
  if (!ctx) {
    throw new Error("useNotificationContext must be used within NotificationProvider");
  }
  return ctx;
}
